import { axios } from '@ben/api/axios';
import type {
  IModularBenefitDetail,
  RenewalConfig,
} from '@ben/shared/types/columbia';
import type { UseMutationOptions } from '@tanstack/react-query';
import { useMutation } from '@tanstack/react-query';

interface UpdateScheduledVersionPayload {
  benefitId?: string;
  versionId?: string;
  benefit: IModularBenefitDetail;
  renewalConfig: RenewalConfig;
}

const updateScheduledVersion = async ({
  benefitId,
  versionId,
  benefit,
  renewalConfig,
}: UpdateScheduledVersionPayload) => {
  const response = await axios.patch<number>(
    `benefits/${benefitId}/versions/${versionId}/`,
    { ...benefit, renewalConfig }
  );
  return response.data;
};

export const useMutationUpdateScheduledVersion = (
  options?: UseMutationOptions<number, unknown, UpdateScheduledVersionPayload>
) => {
  return useMutation<number, unknown, UpdateScheduledVersionPayload>({
    ...options,
    mutationFn: (payload: UpdateScheduledVersionPayload) => {
      if (!payload.benefitId) {
        return Promise.reject(new Error('benefitId must be provided'));
      }
      if (!payload.versionId) {
        return Promise.reject(new Error('versionId must be provided'));
      }
      return updateScheduledVersion(payload);
    },
  });
};
